import localforage from 'localforage'
import { APP_ID } from '@web/common/config'
import Logger from '@web/common/Logger'
import { EMPTY_STATE } from './repeatPolicy'
import type { RepeatState } from './types'

const CLOSE_METHODS = ['overlay', 'close', 'cta', null]

export function stateKey (userId: number, modalId: number): string {
  return `modal_builder_state_${APP_ID}_${userId}_${modalId}`
}

function isState (v: unknown): v is RepeatState {
  if (typeof v !== 'object' || v === null) return false
  const s = v as Record<string, unknown>
  return typeof s.showCount === 'number' &&
    typeof s.closeCount === 'number' &&
    (s.lastShownAt === null || typeof s.lastShownAt === 'number') &&
    CLOSE_METHODS.includes(s.lastCloseMethod as string | null)
}

// Очистка данных сайта и приватное окно обнуляют состояние — принятое ограничение контракта.
export async function readState (userId: number, modalId: number): Promise<RepeatState> {
  try {
    const value = await localforage.getItem(stateKey(userId, modalId))
    return isState(value) ? value : { ...EMPTY_STATE }
  } catch {
    return { ...EMPTY_STATE }
  }
}

export async function writeState (userId: number, modalId: number, state: RepeatState): Promise<void> {
  try {
    await localforage.setItem(stateKey(userId, modalId), state)
  } catch (e) {
    Logger.warn('[modal-builder] не удалось сохранить состояние', e)
  }
}
